import { useMutation } from "@tanstack/react-query";

import { queryClient } from "@config/queryClient";
import feedbackService from "@services/feedback.service";
import { UPDATE_FEEDBACK_MUTATION_KEY, THREAD_AI_CONTEXT_QUERY_KEY } from "@config/query";
import type { IThreadAIContextResponse } from "@interfaces/thread.interface";

interface UpdateFeedbackPayload {
  reasons?: string[];
  comment?: string;
}

export function useUpdateFeedback(threadId: string) {
  return useMutation({
    mutationKey: [UPDATE_FEEDBACK_MUTATION_KEY],
    mutationFn: (payload: UpdateFeedbackPayload) =>
      feedbackService.updateThreadContextFeedback(threadId, payload),
    onSuccess: (_data, variables) => {
      queryClient.setQueryData<IThreadAIContextResponse>(
        [THREAD_AI_CONTEXT_QUERY_KEY, threadId],
        (old) => {
          if (!old?.feedback) return old;
          return {
            ...old,
            feedback: {
              ...old.feedback,
              reasons: variables.reasons ?? old.feedback.reasons,
              comment: variables.comment ?? old.feedback.comment,
            },
          };
        }
      );
    },
  });
}
